<!-- <template>
	<div class="card card-custom card-stretch gutter-b bg-danger">
		<div class="card-header border-0">
			<h3 class="card-title font-weight-bolder text-dark">TODO: {{props }}</h3>
		</div>
		<div class="card-body pt-2">
			{{props}}
		</div>
	</div>
</template> -->

<template>
	<div class="card card-custom card-stretch gutter-b" style="position: relative;">
        <div v-if="!loaded" class="d-flex justify-content-center" style="align-items:center; position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;"> 
                <b-spinner class="m-5" label="Busy"></b-spinner>
        </div>
		<div class="card-header border-0 align-items-center d-flex justify-content-between">
            <h3 class="card-title font-weight-bolder text-dark">
                {{ device.properties && device.properties.label ? device.properties.label : name}} - Starlink Subscription Details
                <!-- Service Line: {{ device.Source.serviceLineNumber }} - Starlink Subscription Details -->
            </h3>
            <div>
                <div class="d-flex align-items-center">
                    <div class="mr-1">Updated: {{ lastUpdated }}</div>
                    <!-- <div class="d-flex align-items-center">
                        <b-icon class="refresh-button h3 font-weight-bolder mb-1" icon="arrow-repeat" v-b-tooltip.hover title="Click for latest Total Data Used" @click="refreshUsage"></b-icon>
                    </div> -->
                </div>
                <!-- <div class="d-flex">
                    <input type="checkbox" v-model="showPrev" id="toggleCheckbox" />
                    <div class="mt-auto ml-2">Show Prev. Month</div>
                </div> -->
            </div>
        </div>

		<div class="card-body pt-0">
            <!-- <h4 class="mt-n2 mb-4" style="font-style: italic;">Product Type: {{ productType }}</h4> -->
			<div v-if="loaded === true && !startDate">
				<h4>
					<i
						class="fa fa-exclamation-circle fa-circle"
						aria-hidden="true"
						style="
							color: red;
							background-image: radial-gradient(at center, white 40%, transparent 40%);
						"
					></i>
					This Starlink has no data available at this time.
				</h4>
			</div>

            <div class="d-flex  justify-content-between">
                <div class="d-flex justify-content-between">
                    <div v-if="loaded===true && startDate">
                        <h4 class="text-dark">Current Billing Period Details:</h4>
                        <div class="SL-details-labels">Start Date: {{ formattedStartDate(this.startDate) }}</div>
                        <div class="SL-details-labels">End Date: {{ formattedEndDate(this.endDate)}}</div>
                        <div class="SL-details-labels">Quota: {{ quotaGb }} GB</div>
                        <div class="SL-details-labels">Data Used: {{ currentDataUsedGB.toFixed(2) }} GB</div>
                        <div class="SL-details-labels">Data
                            <span v-if="currentOverQuotaUsedGigaBytes>0">Overage</span>
                            <span v-else>Remaining</span>
                            : {{ remainingQuotaData("current")}} GB</div>
                        <div class="SL-details-labels">Average Daily Data Used: {{ currentAvgUsedPerDayGB.toFixed(2) }} GB</div>
                    </div>
                    <div style="max-width: 600px;">
                        <apexchart type="pie" :height="height" :options="coptions" :series="coptions.series" />
                    </div>
                </div>
                <div v-if="showPrev" class="d-flex justify-content-between">
                    <div v-if="loaded===true && startDate" style="flex-grow: 1;">
                        <h4 class="text-dark">Previous Billing Period Details:</h4>
                        <div class="SL-details-labels">Start Date: {{ formattedStartDate(this.prevStartDate) }}</div>
                        <div class="SL-details-labels">End Date: {{ formattedEndDate(this.prevEndDate) }}</div>
                        <div class="SL-details-labels">Quota: {{ prevQuotaGb }} GB</div>
                        <div class="SL-details-labels">Data Used: {{ prevDataUsedGB.toFixed(2) }} GB</div>
                        <div class="SL-details-labels">Data 
                            <span v-if="prevOverQuotaUsedGigaBytes>0">Overage</span>
                            <span v-else>Remaining</span>
                            : {{ remainingQuotaData("prev")}} GB</div>
                        <div class="SL-details-labels">Average Daily Data Used: {{ prevAvgUsedPerDayGB.toFixed(2) }} GB</div>
                    </div>
                    <div style="max-width: 600px;">
                        <apexchart type="pie" :height="height" :options="poptions" :series="poptions.series" />
                    </div>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import { downloadCSV } from '@/helpers';
const date = new Date();
const offset = date.getTimezoneOffset() * 60000;
import { mapGetters } from 'vuex';

export default {
	name: 'Starlink_Usage_Details',
    components: {
        // dygraphs: () => import('@/view/content/lib/dygraphs.vue'),
    },
	props: {
        siteid: { Type: Number, required: true},
        name: { Type: String, required: true },
		id: { type: Number, required: true },
		properties: { type: Object, require: false },
        device: { type: Object, require: false },
        widgetId: { type: Number, required: true}
	},
	data() {
		return {
            height: 185,
            poptions: {},
            coptions: {},
            data: [],
            showPrev: true,
            quotaGb: 0,
            startDate: '',
            endDate: '',
            currentDataUsedGB: 0,
            currentUsedPercent: 0,
            currentOverQuotaUsedGigaBytes: 0,
            currentRemainingPercent: 0,
            currentAvgUsedPerDayGB: 0,
            prevQuotaGb: 0,
            prevDataUsedGB: 0,
            prevUsedPercent: 0,
            prevRemainingPercent: 0,
            prevAvgUsedPerDayGB: 0,
            prevStartDate: '',
            prevEndDate: '',
            dailyUsage: [], //since startDate
            productType: null,  
            lastUpdated: null,
            errors: [],
			loaded: false,
		};
	},
    computed: {
		...mapGetters(['currentUser', 'DateRange']),
        // totalDataUsed() {
        //     const totalSum = this.dailyUsage.reduce((sum, obj) => sum + (+obj.totalUsedGigaBytes || 0), 0);
        //     return Number(totalSum.toFixed(2));
        // },
	},
    methods: {
        formattedStartDate(dateInput) {
            const date = new Date(dateInput);
            const options = { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC'};
            const formattedDate = date.toLocaleString(undefined, options);
            return formattedDate;
        },
        formattedEndDate(dateInput) {
            const date = new Date(dateInput);
            const options = { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC'};
            const formattedDate = date.toLocaleString(undefined, options);
            return formattedDate;
        },
        remainingQuotaData(period) {
            if(period==='current') {
                if(this.currentOverQuotaUsedGigaBytes>0) {
                    return this.currentOverQuotaUsedGigaBytes;
                } else {
                    return (this.quotaGb - this.currentDataUsedGB).toFixed(2);
                }
            } else {
                if(this.prevOverQuotaUsedGigaBytes>0) {
                    return this.prevOverQuotaUsedGigaBytes;
                } else {
                    return (this.prevQuotaGb - this.prevDataUsedGB).toFixed(2);
                }
            }
        },
        // calcPercentages() {
        //     const remainingQuotaData = this.quotaGb - this.currentDataUsedGB;
        //     this.percentRemaining = (remainingQuotaData/this.quotaGb*100).toFixed(1);

        //     const totalSum = this.dailyUsage.reduce((sum, obj) => sum + (+obj.totalUsedGigaBytes || 0), 0);
        //     const totalSumUsed = totalSum / this.quotaGb*100;
        //     this.percentUsed = Number(totalSumUsed.toFixed(1));
        // },
        // updateStarlinkMetricData() {
        //     this.loaded = false;
        //     const termId = this.device.Source.kitSerialNumber;
        //     const servLine = this.device.Source.serviceLineNumber;
        //     this.$http.get(`site/${this.siteid}/starlink/metrics/${termId}?${this.metricParam}=${this.metrics}&start=${this.last_timestamp}`).then((res) => {
        //         let newData = false;
        //         const CountOfMetrics = res.data.length;
        //         if(res.data && CountOfMetrics>1) {
        //             for(let i=0; i<CountOfMetrics; i++) {
        //                 const metricData = res.data[i].data;
        //                 const new_data_index = metricData.findIndex(item => item.timestamp > this.last_timestamp);
        //                 if(new_data_index !== -1) {
        //                     const newMetricData = metricData.slice(new_data_index);
        //                     this.starlinkMetrics[i].data = [...this.starlinkMetrics[i].data, ...newMetricData];
        //                     newData = true;
        //                 } else {
        //                     break;
        //                 }
        //             }
        //         } else if (res.data && CountOfMetrics<2) {
        //             const metricData = res.data[0].data;
        //             const new_data_index = metricData.findIndex(item => item.timestamp > this.last_timestamp);
        //             if(new_data_index !== -1) {
        //                 const newMetricData = metricData.slice(new_data_index);
        //                 this.starlinkMetrics[0].data = [...this.starlinkMetrics[0].data, ...newMetricData];
        //                 newData = true;
        //             } 
        //         }
        //         if(newData === true) {
        //             this.processNewAPIData(CountOfMetrics);
        //             this.setLastTimeStamp(res.data);
        //         } else {
        //             this.loaded = true;
        //         }
        //     })
        //     .catch(e => {
        //         this.loaded = true;
        //         this.errors.push(e);
        //         console.log("Error(Updating Starlink Data): ", this.errors);
        //     })
        // },

        getStarlinkUsageDetails(initialLoad=null) {
            // if(this.testing) {
            //     this.quotaGb = 5000;
            //     this.startDate = '2023-03-18T00:00:00.000Z';
            //     this.productType = "Premium Mobile";
            //     this.dailyUsage = [{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-31T00:00:00.000Z","totalUsedGigaBytes":2.01},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-30T00:00:00.000Z","totalUsedGigaBytes":9.54},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-29T00:00:00.000Z","totalUsedGigaBytes":8.38},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-28T00:00:00.000Z","totalUsedGigaBytes":6.63},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-27T00:00:00.000Z","totalUsedGigaBytes":10.36},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-26T00:00:00.000Z","totalUsedGigaBytes":7.9},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-25T00:00:00.000Z","totalUsedGigaBytes":11.05},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-24T00:00:00.000Z","totalUsedGigaBytes":8.23},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-23T00:00:00.000Z","totalUsedGigaBytes":7.96},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-22T00:00:00.000Z","totalUsedGigaBytes":8.76},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-21T00:00:00.000Z","totalUsedGigaBytes":10.6},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-20T00:00:00.000Z","totalUsedGigaBytes":12.74},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-19T00:00:00.000Z","totalUsedGigaBytes":6.43},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-18T00:00:00.000Z","totalUsedGigaBytes":7.56},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-17T00:00:00.000Z","totalUsedGigaBytes":7.35},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-16T00:00:00.000Z","totalUsedGigaBytes":8.08},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-15T00:00:00.000Z","totalUsedGigaBytes":8.88},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-14T00:00:00.000Z","totalUsedGigaBytes":6.29},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-13T00:00:00.000Z","totalUsedGigaBytes":7.64},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-12T00:00:00.000Z","totalUsedGigaBytes":7.13},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-11T00:00:00.000Z","totalUsedGigaBytes":9},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-10T00:00:00.000Z","totalUsedGigaBytes":9.02},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-09T00:00:00.000Z","totalUsedGigaBytes":7.51},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-08T00:00:00.000Z","totalUsedGigaBytes":7.89},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-07T00:00:00.000Z","totalUsedGigaBytes":9.27},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-06T00:00:00.000Z","totalUsedGigaBytes":9.85},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-05T00:00:00.000Z","totalUsedGigaBytes":10.51},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-04T00:00:00.000Z","totalUsedGigaBytes":9.46},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-03T00:00:00.000Z","totalUsedGigaBytes":6.99},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-02T00:00:00.000Z","totalUsedGigaBytes":10.24},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-05-01T00:00:00.000Z","totalUsedGigaBytes":8.87},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-30T00:00:00.000Z","totalUsedGigaBytes":8.37},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-29T00:00:00.000Z","totalUsedGigaBytes":7.82},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-28T00:00:00.000Z","totalUsedGigaBytes":8.46},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-27T00:00:00.000Z","totalUsedGigaBytes":1.85},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-26T00:00:00.000Z","totalUsedGigaBytes":0.09},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-25T00:00:00.000Z","totalUsedGigaBytes":0.08},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-24T00:00:00.000Z","totalUsedGigaBytes":0.08},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-23T00:00:00.000Z","totalUsedGigaBytes":0.09},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-22T00:00:00.000Z","totalUsedGigaBytes":0.08},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-21T00:00:00.000Z","totalUsedGigaBytes":7.89},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-20T00:00:00.000Z","totalUsedGigaBytes":13.34},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-19T00:00:00.000Z","totalUsedGigaBytes":15.27},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-18T00:00:00.000Z","totalUsedGigaBytes":14.08},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-17T00:00:00.000Z","totalUsedGigaBytes":17.91},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-16T00:00:00.000Z","totalUsedGigaBytes":11.41},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-15T00:00:00.000Z","totalUsedGigaBytes":5.12},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-14T00:00:00.000Z","totalUsedGigaBytes":0.08},{"serviceLineNumber":"AST-1518030-74287-44","timestamp":"2023-04-13T00:00:00.000Z","totalUsedGigaBytes":0.08}];
            //     this.lastUpdated = (new Date()).toLocaleString(undefined, {timeZoneName: 'short',});
            //     this.calcPercentages();
            //     this.createPieChart();
            //     this.loaded = true;
            // } else {
            this.loaded = false;
            // const termId = this.device.Source.terminalId;
            const servLine = this.device.Source.serviceLineNumber;
            this.$http.get(`site/${this.siteid}/starlink/usage/${servLine}`).then((res) => {
                // this.testing = res;
                // console.log(res);
                this.lastUpdated = (new Date()).toLocaleString(undefined, {timeZoneName: 'short',});
                this.quotaGb = res.data.currentBillingPeriod.quotaGigaBytes;
                this.startDate = res.data.currentBillingPeriod.startDate;
                this.productType = res.data.subscription.productType;
                this.currentDataUsedGB = (res.data.currentBillingPeriod.totalUsedGigaBytes);
                this.endDate = res.data.currentBillingPeriod.endDate;
                this.currentUsedPercent = (res.data.currentBillingPeriod.quotaUsedPercent);
                this.currentRemainingPercent = (res.data.currentBillingPeriod.quotaRemainingPercent);
                this.currentOverQuotaUsedGigaBytes = (res.data.currentBillingPeriod.totalOverQuotaUsedGigaBytes);
                this.currentAvgUsedPerDayGB = (res.data.currentBillingPeriod.averageUsedPerDayGigaBytes);

    
                this.createPieChart("current");

                if("previousBillingPeriod" in res.data) {
                    this.prevStartDate = res.data.previousBillingPeriod.startDate;
                    this.prevEndDate = res.data.previousBillingPeriod.endDate; 
                    this.prevQuotaGb = res.data.previousBillingPeriod.quotaGigaBytes;
                    this.prevDataUsedGB = (res.data.previousBillingPeriod.totalUsedGigaBytes);
                    this.prevUsedPercent = (res.data.previousBillingPeriod.quotaUsedPercent);
                    this.prevRemainingPercent = (res.data.previousBillingPeriod.quotaRemainingPercent);
                    this.prevOverQuotaUsedGigaBytes = (res.data.previousBillingPeriod.totalOverQuotaUsedGigaBytes);
                    this.prevAvgUsedPerDayGB = (res.data.previousBillingPeriod.averageUsedPerDayGigaBytes);
                    // this.dailyUsage = res.data.usageSinceStartDate.results;
                    this.createPieChart("prev");    
                } else {
                    this.showPrev = false;
                }
                
                this.loaded = true;
            })
            .catch(err => {
                this.loaded = true;
                this.errors.push(err);
                console.log("Error(SL Usage Details): ", this.errors);                                                                            
            })
        // }
        },

        createPieChart(period) {
            // PIE CHART
            let series;
            let labels;

            if(period==="current") {
                let remainingQuotaData = this.quotaGb - this.currentDataUsedGB;
                if(remainingQuotaData<=0) remainingQuotaData = 0;
                var cseries = [this.currentDataUsedGB, remainingQuotaData];
                // if(this.currentOverQuotaUsedGigaBytes > 0) {
                //     var clabels = ['Data Used', 'Data Overage'];
                // } else {
                    var clabels = ['Data Used', 'Data Remaining'];
                // }
                
                series = cseries;
                labels = clabels;
            }
            if(period==="prev") {
                let remainingQuotaData = this.prevQuotaGb - this.prevDataUsedGB;
                if(remainingQuotaData<=0) remainingQuotaData = 0;
                var pseries = [this.prevDataUsedGB, remainingQuotaData];
                // if(this.prevOverQuotaUsedGigaBytes > 0) {
                //     var plabels = ['Data Used', 'Data Overage'];    
                // } else {
                    var plabels = ['Data Used', 'Data Remaining'];
                // }
                series = pseries;
                labels = plabels;
            }
			// Object.keys(d.data.data.bytesSum).forEach(ip => {
			// 	plabels.push(ip);
			// 	pseries.push(d.data.data.bytesSum[ip]);
			// });

			let options = {
				series: series,
				chart: {
					width: 380,
					type: 'pie',
				},
                plotOptions: {
                    pie: {
                        startAngle: -90,
                        endAngle: 270
                    }
                },  
                fill: {
                    colors: ['#003399', '#99ddff']
                },
                markers: {
                    colors: ['#003399', '#99ddff']
                },
                // dataLabels: {
                //     style: {
                //         colors: ['#003399', '#99ddff']
                //     }
                // },
				// title: {
				// 	text: 'Starlink Subscription ',
				// 	align: 'right',
				// },
				labels: labels,
				tooltip: {
					y: {
						formatter: function(val, opts) {
							return val + 'GB';
						},
					},
                    // style: {
                    //     background: '#003399', // Set the desired background color for the tooltip
                    //     color: '#fff', // Set the desired text color for the tooltip
                    // },
				},
                legend: {
                    markers: {
                    fillColors: ['#003399', '#99ddff'], // Set the desired fill colors for the legend markers
                    },
                },
				responsive: [
					{
						breakpoint: 480,
						options: {
							chart: {
								width: 200,
							},
							legend: {
								position: 'bottom',
							},
						},
					},
				],
			};
            if(period==="current") {
                this.coptions = options;
            } else {
                this.poptions = options;
            }
        }
        // refreshUsage() {
        //     const lastDailyUsage = this.dailyUsage[this.dailyUsage.length-1];

        //     this.$http.get(`site/${this.siteid}/starlink/usage/${termId}/${servLine}/update?from=${lastDailyUsage.timestamp}`).then((res) => {

        //     })
        //     .catch(err => {
        //         this.loaded = true;
        //         this.errors.push(err);
        //         console.log("Error(refreshing Usage Details): ", this.errors);                                                                            
        //     })
        // }

        // getMetricsFromStorage() {
        //         let data = JSON.parse(localStorage.getItem(`starlinkMetrics_${this.widgetId}_${this.device.Source.kitSerialNumber}`));
        //         if(!data) {
        //             this.getStarlinkAPIData(true);
        //         } else {
        //             this.stopTimer();
        //             this.loaded = false;
        //             this.starlinkMetrics = data;
        //             this.setLastTimeStamp(this.starlinkMetrics);
        //             this.setOptions();
        //             const CountOfMetrics = this.starlinkMetrics.length;
        //             this.processNewAPIData(CountOfMetrics, 'fromStorage');
        //             this.updateStarlinkMetricData();
        //             this.updateGraphData();
        //         }
        // },
        // saveToStorage(res) {
        //     if(!this.device.Source.kitSerialNumber) {
        //         const starlink = JSON.parse(this.device.Source);
        //         this.device.Source = starlink; 
        //     }
        //     localStorage.setItem(`starlinkMetrics_${this.widgetId}_${this.device.Source.kitSerialNumber}`, JSON.stringify(res))
        // },
        
    },
    created() {
        // //converting to object stored as string from MySQL  
        if(!this.device.Source.serviceLineNumber) {
                const starlink = JSON.parse(this.device.Source);
                this.device.Source = starlink; 
            } 
    },
    beforeMount() {
        this.getStarlinkUsageDetails();
    },
    mounted() {      
    },

    beforeUpdate() {
    },
    updated() {
    },
    unmounted() {
    },
    beforeDestroy() {
    }


};
</script>

<style>
.SL-details-labels {
    font-weight: 500;
    font-size: 1.2em;
}
.refresh-button:hover {
  cursor: pointer;
}
</style>